import { render } from "./message-preview.vue?vue&type=template&id=615e295e&lang=pug"
import script from "./message-preview.vue?vue&type=script&lang=js"
export * from "./message-preview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__